"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Popper = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof"));
var _inheritsLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/inheritsLoose"));
var _core = require("@popperjs/core");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireWildcard(require("react"));
var _customPropTypes = _interopRequireDefault(require("../../util/custom-prop-types"));
var _Trigger = require("../Trigger/Trigger");
var _TriggerButton = require("../TriggerButton/TriggerButton");
var _excluded = ["children", "onOpen", "onClose", "triggered", "offset", "placement", "popperJSOptions", "shouldFocusTriggered", "shouldUseYieldCallback"];
/**
 * Make sure the node has a ref, creating one if it does not exist.
 * Existing refs can be from React.createRef() or of callback form.
 *
 * @param node {node} The node to augment
 * @param callback {function} A callback called with the ref value
 * @return {node} The augmented node
 */
var augmentWithRef = function augmentWithRef(node, callback) {
  if (typeof node.ref === 'function') {
    // Callback ref exists
    var callbackRef = node.ref;
    var _ref = function _ref(current) {
      callback({
        current: current
      });
      callbackRef(current);
    };
    return /*#__PURE__*/(0, _react.cloneElement)(node, {
      ref: _ref
    });
  }
  if (node.ref) {
    // React.createRef() exists
    callback(node.ref);
    return node;
  }
  // No ref exists, create a new one
  var ref = /*#__PURE__*/(0, _react.createRef)();
  callback(ref);
  return /*#__PURE__*/(0, _react.cloneElement)(node, {
    ref: ref
  });
};

/**
 * `Popper` is a `Trigger` that enhances the `triggered` content with positioning from
 * the [Popper.js](https://popper.js.org/) library.
 *
 * **IE11 Support:**
 * Popper.js requires [polyfills](https://popper.js.org/docs/v2/browser-support/#ie11) to support
 * IE11. The polyfills are not provided by Popper.js or Constellation;
 * your application must install these.
 *
 * @related ['DropdownPopper', 'MenuPopper', 'TooltipPopper', 'Trigger']
 * @since 7.0.0
 */
var Popper = /*#__PURE__*/function (_Component) {
  (0, _inheritsLoose2.default)(Popper, _Component);
  function Popper(props) {
    var _this;
    _this = _Component.call(this, props) || this;
    _this.onOpen = function () {
      _this.updatePopperJS();
      _this.props.onOpen();
    };
    _this.onClose = function () {
      _this.updatePopperJS();
      _this.props.onClose();
    };
    _this.destroyPopperJS = function () {
      if (_this.popper) {
        _this.popper.destroy();
        _this.popper = null;
      }
    };
    _this.getPopperJSReference = function () {
      if ((0, _typeof2.default)(_this.props.popperJSReference) === 'object') {
        return _this.props.popperJSReference.current;
      }
      return _this.triggerRef.current;
    };
    /**
     * Check for popper/trigger/triggered existance and initialize/destroy popper accordingly.
     */
    _this.updatePopperJS = function () {
      if (!_this.popper && _this.getPopperJSReference() && _this.triggeredRef.current) {
        _this.initPopperJS();
      } else if (_this.popper && (!_this.triggerRef.current || !_this.triggeredRef.current)) {
        _this.destroyPopperJS();
      }
    };
    _this.initPopperJS = function () {
      var defaultOptions = {
        placement: _this.props.placement,
        modifiers: [{
          name: 'offset',
          options: {
            offset: _this.props.offset
          }
        }],
        onFirstUpdate: function onFirstUpdate() {
          if (_this.props.shouldFocusTriggered) {
            _this.triggeredRef.current.focus();
          }
        }
      };
      if (_this.arrowRef.current) {
        defaultOptions.modifiers.push({
          name: 'arrow',
          options: {
            element: _this.arrowRef.current
          }
        });
      }
      var options;
      if (typeof _this.props.popperJSOptions === 'function') {
        options = _this.props.popperJSOptions(defaultOptions);
      } else {
        options = Object.assign({}, defaultOptions, _this.props.popperJSOptions);
      }
      _this.popper = (0, _core.createPopper)(_this.getPopperJSReference(), _this.triggeredRef.current, options);
    };
    /**
     * A render function that will be passed to `Trigger` to render the triggered content.
     */
    _this.renderTriggered = function (spreadProps, close) {
      var triggered = _this.props.triggered;
      var triggeredProps = Object.assign({
        arrowRef: _this.arrowRef
      }, spreadProps);
      if (_this.triggerRef) {
        triggeredProps.triggerRef = _this.triggerRef;
      }
      if (_this.triggeredRef) {
        triggeredProps.ref = _this.triggeredRef;
      }
      var triggeredContent;
      if (typeof triggered === 'function') {
        triggeredContent = triggered(triggeredProps, close);
      } else {
        triggeredContent = /*#__PURE__*/(0, _react.cloneElement)(_react.Children.only(triggered), triggeredProps);
      }

      // Capture or create the ref to be used with popper.js
      if (!_this.triggeredRef) {
        triggeredContent = augmentWithRef(triggeredContent, function (ref) {
          _this.triggeredRef = ref;
        });
      }
      return triggeredContent;
    };
    _this.arrowRef = /*#__PURE__*/(0, _react.createRef)();
    return _this;
  }
  var _proto = Popper.prototype;
  _proto.componentDidMount = function componentDidMount() {
    var _this2 = this;
    this.updatePopperJS();
    // Wait for the popperJSReference ref to initialize
    // TODO: Fix this in refactor for 9x
    setTimeout(function () {
      if (_this2.props.popperJSReference === 'object') {
        _this2.updatePopperJS();
      }
    }, 100);
  };
  _proto.componentDidUpdate = function componentDidUpdate() {
    this.updatePopperJS();
  };
  _proto.componentWillUnmount = function componentWillUnmount() {
    this.destroyPopperJS();
  };
  _proto.render = function render() {
    var _this3 = this;
    var _this$props = this.props,
      children = _this$props.children,
      onOpen = _this$props.onOpen,
      onClose = _this$props.onClose,
      triggered = _this$props.triggered,
      offset = _this$props.offset,
      placement = _this$props.placement,
      popperJSOptions = _this$props.popperJSOptions,
      shouldFocusTriggered = _this$props.shouldFocusTriggered,
      shouldUseYieldCallback = _this$props.shouldUseYieldCallback,
      rest = (0, _objectWithoutProperties2.default)(_this$props, _excluded);
    var triggerProps = {};
    if (this.triggerRef) {
      triggerProps.ref = this.triggerRef;
    }
    var triggerContent;
    if (typeof children === 'function') {
      triggerContent = children(triggerProps);
    } else {
      triggerContent = /*#__PURE__*/(0, _react.cloneElement)(_react.Children.only(children), triggerProps);
    }

    // Capture or create the ref to be used with popper.js
    if (!this.triggerRef) {
      triggerContent = augmentWithRef(triggerContent, function (ref) {
        _this3.triggerRef = ref;
      });
    }
    return /*#__PURE__*/_react.default.createElement(_Trigger.Trigger, (0, _extends2.default)({
      triggered: this.renderTriggered,
      onOpen: this.onOpen,
      onClose: this.onClose,
      shouldUseYieldCallback: shouldUseYieldCallback
    }, rest), triggerContent);
  };
  return Popper;
}(_react.Component);
exports.Popper = Popper;
Popper.displayName = 'Popper';
Popper.propTypes = process.env.NODE_ENV !== "production" ? {
  /**
   * The `Trigger` `defaultOpen` prop.
   */
  defaultOpen: _propTypes.default.bool,
  /**
   * The `Trigger` `children` content.
   * The trigger will be passed `ref` for positioning with the [Popper.js](https://popper.js.org/)
   * library.
   * **The node must be a single element capable of accepting props/refs (no fragments).**
   */
  children: _propTypes.default.oneOfType([_propTypes.default.element, _propTypes.default.func]),
  /**
   * The `Trigger` `isOpen` prop.
   *
   * @since 8.24.0
   */
  isOpen: _propTypes.default.bool,
  /**
   * The `Trigger` `onOpen` handler.
   */
  onOpen: _propTypes.default.func,
  /**
   * The `Trigger` `onClose` hander.
   */
  onClose: _propTypes.default.func,
  /**
   * The [`offset`](https://popper.js.org/docs/v2/modifiers/offset/#offset-1) option for the
   * [`Offset`](https://popper.js.org/docs/v2/modifiers/offset/) modifier.
   */
  offset: _propTypes.default.oneOfType([_propTypes.default.array, _propTypes.default.func]),
  /**
   * Sets the [`placement`](https://popper.js.org/docs/v2/constructors/#placement) option.
   */
  placement: _customPropTypes.default.popperPlacement,
  /**
   * An Popper.js [`options`](https://popper.js.org/docs/v2/constructors/#options) object that
   * will be spread into the default options, or a function that receives the default options
   * as the only parameter and returns an options object.
   */
  popperJSOptions: _propTypes.default.oneOfType([_propTypes.default.shape({}), _propTypes.default.func]),
  /**
   * By default, the trigger will be used as the reference point when positioning the triggered
   * content. To override this behavior, you can pass the ref object of another node you would
   * like to position the content relative to.
   *
   * @since 8.28.0
   */
  // eslint-disable-next-line zillow/react/forbid-prop-types
  popperJSReference: _propTypes.default.object,
  /**
   * Focus the `triggered` node once the popover is positioned.
   */
  shouldFocusTriggered: _propTypes.default.bool,
  /**
   * The `Trigger` `triggered` content.
   *
   * When `triggered` is a node, the content will be passed `ref` and `arrowRef` for positioning
   * with the [Popper.js](https://popper.js.org/) library.
   *
   * When `triggered` is a function, the function will provide `prop` that should be spread into
   * the content, and a `close` function that can be called to close the popper.
   *
   * **Trigger content must be a single element capable of accepting props/refs (no fragments).**
   */
  triggered: _propTypes.default.oneOfType([_propTypes.default.element, _propTypes.default.func]).isRequired,
  /**
   * Close the trigger when the user scrolls away from the trigger node.
   */
  shouldCloseOnViewportLeave: _propTypes.default.bool,
  /**
   * When `true`, the `onOpen` and `onClose` handlers will be wrapped in `yieldCallback`
   */
  shouldUseYieldCallback: _propTypes.default.bool
} : {};
Popper.defaultProps = {
  children: /*#__PURE__*/_react.default.createElement(_TriggerButton.TriggerButton, null),
  defaultOpen: false,
  onClose: function onClose() {},
  onOpen: function onOpen() {},
  offset: function offset(_ref2) {
    var placement = _ref2.placement;
    if (placement.indexOf('start') >= 0) {
      return [-20, 20];
    }
    if (placement.indexOf('end') >= 0) {
      return [20, 20];
    }
    return [0, 20];
  },
  placement: 'bottom-start',
  popperJSOptions: {},
  shouldFocusTriggered: true,
  shouldCloseOnViewportLeave: false,
  shouldUseYieldCallback: true
};